import { css } from 'styled-components';

export const wrapper = () => css`
  width: 100%; 
  flexGrow: 1;
`;
